<template>
  <el-row :gutter="20" class="panel-group">
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="order" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            救援任务数
          </div>
          <count-to :start-val="0" :end-val="parseInt(data.task_num)" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>

    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="order" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            救援任务上报数
          </div>
          <count-to :start-val="0" :end-val="parseFloat(data.userRescue_num)" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>

    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="newmember" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            个人会员数
          </div>
          <count-to :start-val="0" :end-val="parseInt(data.userIndividual_num)" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>

    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="newmember" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            团队会员数
          </div>
          <count-to :start-val="0" :end-val="parseInt(data.report_num)" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>

    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="newmember" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            救援队员数
          </div>
          <count-to :start-val="0" :end-val="parseInt(data.userTeam_num)" :duration="3000" class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
// import api from '@/api/report' // 和数据交互相关写在api 方便复用
import CountTo from 'vue-count-to'
import { mapGetters } from 'vuex'
export default {
  components: {
    CountTo
  },
  data() {
    return {
      data: {
        task_num: 0,
        report_num: 0,
        userIndividual_num: 0,
        userTeam_num: 0,
        userRescue_num: 0
      }
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  created() {
    this.getCountNum()
  },
  methods: {
    getCountNum() { // 获取统计数据
      // api.GetCountNum().then(res => {
      //   this.data = res.data
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  .card-panel-col{
    margin-bottom: 20px;
  }
  .card-panel {
    height: 70px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color:#409EFF;
    border: 1px solid #ddd;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    .card-panel-icon-wrapper {
      float: left;
      padding: 17px 0px 0px 8px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
      width: 30%;
    }
    .card-panel-icon {
      float: left;
      font-size: 35px;
      .svg-icon{
        width: 100% !important;
      }
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      padding: 12px 10px 0px 0px;
      text-align: right;
      margin-left: 0px;
      width: 70%;
      .card-panel-text {
        line-height: 16px;
        color: #999;
        font-size: 15px;
        margin-bottom: 8px;
      }
      .card-panel-num {
        font-size: 20px;
      }
      .card-panel-foot {
        margin-top: 12px;
        color: #999;
      }
    }
  }
  .card-panel-important{
    color: #000;
  }
}
</style>
